module.exports = __webpack_public_path__ + "static/images/jf-spike-msz.203c0a0.png";